import React from 'react';
import './MediaUpload.scss';
import EmptyFileView from './EmptyFileView';
import ScanningView from './ScanningView';
import ResultView from './ResultView';
import { UPLOADMSG, MEDIASTATUS} from '../../constants/upload';
import { ADMIN_ROLE } from '../../constants/global';
import {Context} from '../../context/dataStore';

const MediaUpload = ({mediaMeta, setMediaMeta, onUpload, org_role, org_id, uploadType, uploadLimit}) => {
 
  const [uploadFileName, setUploadFileName] = React.useState(mediaMeta.imageName);
  const [uploadStatus, setUploadStatus] = React.useState(mediaMeta.status);
  const [uploadFileSize, setUploadFileSize] = React.useState(mediaMeta.size);
  const [uploadDate, setUploadDate] = React.useState('');
  const {postModule} = React.useContext(Context);
  
  React.useEffect(()=>{
    setUploadFileName(mediaMeta.imageName);
    setUploadStatus(mediaMeta.status);
    setUploadFileSize(mediaMeta.size);
    const date = new Date(mediaMeta.timestamp);
    setUploadDate(date.toLocaleDateString('en-US'));
  }, [mediaMeta]);
  
  const onFileLoad = (e)=> {
    
    const curFile= e.target.files[0];
    const fileName = curFile?.name;  

    let num = curFile.size;
    let displaySize = '';
    let fileType = fileName.split('.')[1].toLowerCase();
    if(uploadLimit.types.includes(`.${fileType}`)){
      //checksize
      let max = uploadLimit.maxSize;
      if(max>10000000)
        displaySize = (num/1000000).toFixed(1)+'MB';
      else{
        displaySize = (num/1000).toFixed(1)+'KB';
      }

      if(curFile.size>uploadLimit.maxSize){
        const newmeta = {...mediaMeta, status:'error_size', imageName: fileName, size: displaySize};
        setMediaMeta(newmeta);
        return;
      }
      const newmeta = {...mediaMeta, status:MEDIASTATUS.SCANNING, imageName: fileName, size: displaySize};
      setMediaMeta(newmeta);

      const reader = new FileReader();
      reader.readAsDataURL(curFile);
  
      reader.onload = async (fileLoadedEvent) => {
        const encodedImage = fileLoadedEvent.target.result;
        let sendData = [{
          "category_id": 12,
          "id": 3138,
          "module_id": 137,
          "question_group_id": 215,
          "current_value":{
            fileName,
            encodedImage
          },
          "saved_from":"MEDIA"
        }];
        
        const result = await postModule(sendData, org_id);
        const {status, data} = result;
        console.log(data.status);
        if(status!==200||data?.status==='Error'){
          const newmeta = {...mediaMeta, status:MEDIASTATUS.ERROR};
          setMediaMeta(newmeta);
        }
        else{
          onUpload(uploadType, newmeta);
        }
      };
  
      reader.onloadend = async () => {
      };
      
      reader.onerror = async () => {
       
      };

    }else{
      //setUploadFileName(fileName);
      //setUploadStatus('invalid');
    }
  };
  /* for admin only */
  const onPublish = () => {
    console.log('approve');
    const newmeta = {...mediaMeta, status:MEDIASTATUS.APPROVED};
    setMediaMeta(newmeta);
  };

  const onReject = () => {
    console.log('reject');
    const newmeta = {...mediaMeta, status:MEDIASTATUS.REJECTED};
    setMediaMeta(newmeta);
  };

  const displayStatus = () =>{
    if(uploadStatus===MEDIASTATUS.SCANNING){
      return (<span className='uploadfileFont'>Scanning documents...</span>);
    }
    if(uploadStatus?.startsWith(MEDIASTATUS.SUCCESS)){
      return (<><span className={"cb-icon cb-check-fill cb-green1-color"} style={{marginRight:'10px'}}></span><span className='uploadfileFont' style={{color: 'green'}}>{UPLOADMSG[uploadStatus]}&nbsp;{uploadDate}</span></>);
    }
    if(uploadStatus?.startsWith(MEDIASTATUS.ERROR)){
      return (<><span className={"cb-icon cb-exclamation-fill cb-red1-color"} style={{marginRight:'10px'}}></span><span className='uploadfileFont' style={{color: '#7f1a26'}}>{UPLOADMSG[uploadStatus]}</span></>);
    }

    if(uploadStatus?.startsWith(MEDIASTATUS.APPROVED)){
      return (<><span className={"cb-icon cb-check-fill cb-green1-color"} style={{marginRight:'10px'}}></span><span className='uploadfileFont' style={{color: 'green'}}>{UPLOADMSG[uploadStatus]}&nbsp;{uploadDate}</span></>);
    }

    if(uploadStatus?.startsWith(MEDIASTATUS.REJECTED)){
      return (<><span className={"cb-icon cb-exclamation-fill cb-red1-color"} style={{marginRight:'10px'}}></span><span className='uploadfileFont' style={{color: '#7f1a26'}}>{UPLOADMSG[uploadStatus]}&nbsp;{uploadDate}</span></>);
    }
    return null;
  }; 

  const displayView = () => {
    if(uploadStatus===''||uploadStatus===undefined){
      return <EmptyFileView onFileLoad={onFileLoad} uploadStatus={uploadStatus} org_role={org_role} acceptTypes={uploadLimit.types}/>;
    }
    if(uploadStatus===MEDIASTATUS.SCANNING){
      return <ScanningView fileName={uploadFileName} fileSize={uploadFileSize} org_role={org_role} />;
    }
    //if(uploadStatus?.startsWith('success')||uploadStatus?.startsWith('error')){
      return <ResultView fileName={uploadFileName} onFileLoad={onFileLoad} 
              fileSize={uploadFileSize} org_role={org_role} 
              uploadStatus={uploadStatus}
              onPublish={onPublish}
              onReject={onReject}
              acceptTypes={uploadLimit.types}
              />;
    //}
  };

  const renderUploadFile = () => (
    <div className='uploadcontainer'>
      <span className={org_role===ADMIN_ROLE?'uploadrowadmin uploadfileFont':'uploadrow uploadfileFont'}> File Name: </span>

      {displayView()}

      <div className={org_role===ADMIN_ROLE?'uploadrowadmin uploadfileFont':'uploadrow uploadfileFont'}>
      {displayStatus()}
      </div>
  </div>
  );

  return(
      <>
      {renderUploadFile()}
      </>
  );
}

export default MediaUpload;